/**
 * Created by pandemio on 11/12/18.
 */
import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Col } from 'reactstrap';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Generic modal. Set whatever you want to put in this message box.
 */
class ModalAddNewProfile extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: this.props.data.visible,
            answer: false
        };
        this.toggle = this.toggle.bind(this);
        this.toogleYes = this.toogleYes.bind(this);
        this.toogleNo = this.toogleNo.bind(this);
    }

    /**
     * Hide or shows the window
     */
    toggle() {
        this.setState({
            modal: !this.state.modal
        },()=>{
            // Updates the parent (send it owns to state to update it)
            this.props.updateParent(this.state);
        });
    }

    /**
     * Toogles when yes
     */
    toogleYes(){
        this.setState({
            modal: !this.state.modal,
            answer: true
        },()=>{
            // Updates the parent (send it owns to state to update it)
            this.props.updateParent(this.state);
        });

    }

    /**
     * Toogles when no
     */
    toogleNo(){
        this.setState({
            modal: !this.state.modal,
            answer: false
        },()=>{
            // Updates the parent (send it owns to state to update it)
            this.props.updateParent(this.state);
        });
    }

    // Render a generic modal. The body text should be sent in the text
    render() {
        return (
            <div>
                <Modal isOpen={this.state.modal} toggle={this.toggle}>
                    <ModalHeader toggle={this.toggle}>
                        <Translate id="general.attention" />
                    </ModalHeader>
                    <ModalBody>
                        <Translate id="profile-register.add-new-student-spaces-left" />
                        <hr/>
                        <p className="text-center">
                            <Button color="success" onClick={this.toogleYes}>
                                <Translate id="profile-register.yes-add-new-student" />
                            </Button>
                        </p>
                        <p className="text-center">
                            <Button color="warning" onClick={this.toogleNo}>
                                <Translate id="profile-register.no-add-new-student" />
                            </Button>
                        </p>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default ModalAddNewProfile;


// WEBPACK FOOTER //
// ./src/components/modals/modal-add-another-profile.js